import React, { useEffect } from 'react';
import { useTranslation }   from 'react-i18next';
import TextField            from '@material-ui/core/TextField';
import InputAdornment       from '@material-ui/core/InputAdornment';
import CircularProgress     from '@material-ui/core/CircularProgress';
import PropTypes            from 'prop-types';
import { useKeychains }     from '@karpeleslab/klb-react-services';

const ShellKeychainSelector = ({ value, setValue, label = null, helperText = null, disabled = false, required = false, ...rest }) => {
	const { t } = useTranslation();
	const [keychains, fetch, loading] = useKeychains();

	useEffect(() => {
		fetch({}, { results_per_page: 100 });
	}, []);

	return (
		<TextField
			label={label ?? t('shell_keychain_selector_label')}
			helperText={helperText ?? t('shell_keychain_selector_helperText')}
			value={value}
			onChange={e => setValue(e.target.value)}
			select
			fullWidth
			disabled={disabled || !keychains}
			required={required}
			variant='outlined'
			InputProps={loading ?
				{
					endAdornment:
						(<InputAdornment position='end'>
							<CircularProgress size={30} thickness={1}/>
						</InputAdornment>)
				} : undefined
			}
			SelectProps={{
				native: true
			}}
			{...rest}
		>
			<option value='none'>{t('shell_keychain_selector_do_not_use')}</option>
			{!loading && keychains && keychains.data.map(
				keychain => <option key={keychain.Keychain__} value={keychain.Keychain__}>{keychain.Label}</option>
			)}
		</TextField>
	);
};

export default ShellKeychainSelector;

ShellKeychainSelector.propTypes = {
	disabled: PropTypes.bool,
	helperText: PropTypes.string,
	label: PropTypes.string,
	required: PropTypes.bool,
	setValue: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired
};
